import { resolveCsrfToken } from '../../components/write-request.js';

export function resolveAdminGhostCoversDom() {
    const pageRoot = document.querySelector('[data-page-view="admin-ghost-covers"]');
    if (!(pageRoot instanceof HTMLElement)) {
        return null;
    }

    const searchUrl = String(pageRoot.dataset.ghostCoversSearchUrl ?? '').trim();
    const addUrl = String(pageRoot.dataset.ghostCoversAddUrl ?? '').trim();
    const reorderUrl = String(pageRoot.dataset.ghostCoversReorderUrl ?? '').trim();

    const searchInput = pageRoot.querySelector('[data-ghost-covers-search-input]');
    const searchStatus = pageRoot.querySelector('[data-ghost-covers-search-status]');
    const searchResults = pageRoot.querySelector('[data-ghost-covers-search-results]');
    const searchResultTemplate = pageRoot.querySelector('[data-ghost-search-result-template]');
    const grid = pageRoot.querySelector('[data-ghost-covers-grid]');
    const coverCardTemplate = pageRoot.querySelector('[data-ghost-cover-card-template]');
    const previewGrid = pageRoot.querySelector('[data-ghost-preview-grid]');
    const previewEmpty = pageRoot.querySelector('[data-ghost-preview-empty]');
    const total = pageRoot.querySelector('[data-ghost-covers-total]');
    const guidance = pageRoot.querySelector('[data-ghost-covers-guidance]');
    const empty = pageRoot.querySelector('[data-ghost-covers-empty]');
    const csrfToken = resolveCsrfToken();

    if (
        searchUrl === ''
        || addUrl === ''
        || reorderUrl === ''
        || csrfToken === ''
        || !(searchInput instanceof HTMLInputElement)
        || !(searchStatus instanceof HTMLElement)
        || !(searchResults instanceof HTMLElement)
        || !(searchResultTemplate instanceof HTMLTemplateElement)
        || !(grid instanceof HTMLElement)
        || !(coverCardTemplate instanceof HTMLTemplateElement)
        || !(previewGrid instanceof HTMLElement)
        || !(previewEmpty instanceof HTMLElement)
        || !(total instanceof HTMLElement)
        || !(guidance instanceof HTMLElement)
        || !(empty instanceof HTMLElement)
    ) {
        return null;
    }

    return {
        addUrl,
        coverCardTemplate,
        csrfToken,
        empty,
        guidance,
        grid,
        previewEmpty,
        previewGrid,
        reorderUrl,
        searchInput,
        searchResults,
        searchResultTemplate,
        searchStatus,
        searchUrl,
        total,
    };
}
